<template>
  <div class="box">
    <!-- 移除 v-if，改用 v-show 或直接渲染，防止容器突然出现导致的浏览器缩放重算 -->
    <div v-show="data" v-html="data" class="content" />
  </div>
</template>

<script>
import { getInfoByType } from '@/api/user';
export default {
  data() {
    return {
      data: ''
    };
  },
  mounted() {
    this.fixViewport();
    this.getInfoByType();
  },
  methods: {
    // 强制设置移动端视口，防止文字因自动缩放而变小
    fixViewport() {
      let meta = document.querySelector('meta[name="viewport"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'viewport';
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
      meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    },
    getInfoByType(){
      getInfoByType({type:this.$route.query.type}).then(response => {
        let resData = response.data || '';
        // 处理空格换行
        this.data = resData.replace(/ /g, '&nbsp;').replace(/\n/g, '<br>');
      });   
    },
  }
}
</script>

<style lang="scss" scoped>
.box{
  padding: 15px;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
  /* 基础字体锁定 */
  font-size: 18px !important;
}

/* 🔥 终极缩放锁定 */
.content {
  display: block;
  width: 100%;
  white-space: pre-wrap !important;
  word-break: break-all !important;
  line-height: 1.8 !important;
  
  /* 核心：禁止系统自动调整文字大小 */
  -webkit-text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;

  /* 字体大小锁定 */
  font-size: 18px !important;
}

/* 🔥 深度穿透：强制锁定所有内部富文本标签 */
::v-deep .content,
::v-deep .content * {
  font-size: 18px !important;
  line-height: 1.8 !important;
  font-weight: normal !important;
  -webkit-text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
}
</style>


// WEBPACK FOOTER //
// Xieyi.vue?77ad7737